import React from "react";
import PolicyPage from "@/components/PolicyPage";

export default function PrivacyPolicy() {
  return <PolicyPage docKey="privacy" metaKey="privacy" slug="privacy" />;
}
